import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { createUserSuccess, createUserFailure } from "../../Action/auth/createUserAction";
import { CREATE_USER } from "../../Action/actionTypes";
import { notifyPromise } from "../../../Utils/Helper";

function* createUserRequest(action) {
  try {
    const { data } = yield notifyPromise(
      API.post("/create-user", action?.payload?.payload),
      "Creating user and trading account..."
    );
    if (data?.meta?.code === 200) {
      yield put(createUserSuccess(data?.data));
    } else {
      yield put(createUserFailure());
    }
    if (action?.payload?.callback) {
      yield call(action.payload.callback, data);
    }
  } catch (error) {
    yield put(createUserFailure());
    // Let the form re-enable itself; the error toast comes from notifyPromise
    if (action?.payload?.callback) {
      yield call(action.payload.callback, error?.response?.data || null);
    }
  }
}

export function* watchCreateUserAPI() {
  yield takeEvery(CREATE_USER, createUserRequest);
}

export default function* rootSaga() {
  yield all([watchCreateUserAPI()]);
}